<template>
    <div>

        <lottie :options="defaultOptions" :height="height" :width="width" v-on:animCreated="handleAnimation" />

    </div>

</template>

<script>
    import Lottie from './lottie.vue';
    import * as gota from '@/assets/animations/gota.json';
    import * as gotared from '@/assets/animations/gota-red.json';

    export default {
        name: 'gota',
        props: ['percent','width','height','red'],
        data() {
            return {
                defaultOptions: { 
                    animationData: (!!this.red) ? gotared : gota
                },
                animationSpeed: 1,
                anim: '',
            }
        },
        methods: {
            handleAnimation: function (anim) {

                this.anim = anim;
                this.anim.stop();

                let frames = this.anim.getDuration(true);

                let finish = this.percent * frames / 100;

                if(finish < 1){
                    finish = 1;
                }

                if (finish != 0) {
                    this.anim.playSegments([0, finish], true);
                }

            },
        },
        components: {
            'lottie': Lottie
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/parts/gota.vue